import "./error.scss";

export const ErrorComponent = () => {
  return (
    <div className="error_container">
      <p>Faild to fetch data 😫😫</p>
      <p>Please check your connections and reload the page.</p>
    </div>
  );
};
